import styled from 'styled-components';

export const FileInputUI = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  width: 100%;
`;

export const FileNameUI = styled.div`
  flex: 1;
  display: flex;

  padding: 0 10px;
  align-items: center;
  border-top: 1px solid #dedede;
  border-left: 1px solid #dedede;
  border-right: 1px solid #dedede;
  border-bottom: 1px solid #dedede;
  background-color: #fff;
`;

export const ButtonUI = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 5px;
  background: none;
  margin: 0;
  color: #1272ba;
  width: 100%;
  padding: 6px 10px;
  height: 100%;
  border: 1px solid #1272ba;

  &:hover {
    background: #1272ba;
    color: #fff;
  }
`;
